module.exports = __webpack_public_path__ + "img/测点_控制柜.5c43a0b7.png";